import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider) {
	$stateProvider.state('account', {
		abstract: true,
		parent: 'app'
	});
}

app.config(stateConfig);
